import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class OpenTicketGenieFlag extends Component {
    state = {
        OpenTicketGenieFlagLists:[],
        OpenTicketGenieFlagValue: '',
        isOpenTicketGenieFlagLoading: true
    };
    componentDidMount(){
        this.getOpenTicketGenieFlag();
    }
    restOpenTicketGenieFlagFilter() {
        this.setState({
            OpenTicketGenieFlagValue: [],
        })
    }
    getOpenTicketGenieFlag(){
        axios.get(config.get('API_URL')+'/filters/get-genie-flag/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_type: this.props.userType,
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((ginie_flg, index) => {
                    this.state.OpenTicketGenieFlagLists.push({value: ginie_flg.ginie_flg, label: ginie_flg.ginie_flg})
                });
            }
            this.setState({
                isOpenTicketGenieFlagLoading: false
            })
        });

    }


    changeOpenTicketGenieFlag(optionSelected){
        let value='';
        let tenderArray = [];
        if(optionSelected.length < 1){
            value = null;
            tenderArray = '';
        }
        else{
            optionSelected.map((ids, i) => {
                tenderArray.push(ids.value)
                var index = this.state.OpenTicketGenieFlagLists.findIndex(obj => obj.value==ids.value);
                this.state.OpenTicketGenieFlagLists.move(index,0).join(',');
            });
        }
        this.props.onSelectOpenTicketGenieFlag(optionSelected, tenderArray);
        this.setState({
            OpenTicketGenieFlagValue:optionSelected,
        });

    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="event_name"
                isMulti
                value={this.state.OpenTicketGenieFlagValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeOpenTicketGenieFlag.bind(this)}
                options={this.state.OpenTicketGenieFlagLists}
                placeholderButtonLabel="Select [Genie Flag]"
                isLoading={this.state.isOpenTicketGenieFlagLoading}
            />
        );

    }
}
export default OpenTicketGenieFlag;